/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-nested-ternary */
import React, { useRef, useCallback, useState } from 'react'
import { FormHandles } from '@unform/core'
import { useHistory } from 'react-router-dom'
import { Form } from '@unform/web'
import moment from 'moment'
import * as Yup from 'yup'

import { FiArrowLeft, FiArrowRight, FiPlus, FiUser, FiX } from 'react-icons/fi'
import { Collapse } from '@material-ui/core'
import { MdSecurity } from 'react-icons/md'
import { BiCake } from 'react-icons/bi'
import calculaIdade from '../../utils/calculaIdade'

import getValidationErrors from '../../utils/getValidationErrors'
import usePersistedState from '../../hooks/usePersistedState'
import validaCPF from '../../utils/validaCPF'

import InputSelect from '../../components/InputSelect'
import InfoBox from '../../components/InfoBox'
import Header from '../../components/Header'
import Button from '../../components/Button'
import Input from '../../components/Input'

import {
  Container,
  Content,
  BtnContato,
  RadioButton,
  BenefBox,
  BenefBoxInfos,
} from './styles'
import { UserData, Participant } from '../../utils/interfaces'

const ParticipantsList: React.FC = () => {
  const [userData] = usePersistedState<UserData>('userData', {} as UserData)

  const [participantsList, setParticipantsList] = usePersistedState<
    Participant[]
  >('participantsGroup', [])

  const [grauParent, setGrauParent] = useState({
    label: '',
    value: '',
  })

  const [addNew, setAddNew] = useState(true)
  const [addParticipant, setAddParticipant] = useState('S')
  const [thisParticipant, setThisParticipant] = useState<Participant>(
    {} as Participant,
  )

  const formRef = useRef<FormHandles>(null)
  const history = useHistory()

  const handleChangeGrauParentesco = useCallback(e => {
    const t = e
    setGrauParent(t)
  }, [])

  const handleRemove = useCallback(
    id => {
      setParticipantsList(() =>
        participantsList.filter((participant, idx) => idx !== id),
      )
    },
    [participantsList, setParticipantsList],
  )

  const handleSubmit = useCallback(
    async formData => {
      if (addParticipant === 'S') {
        if (
          formData.name === '' &&
          formData.cpf === '' &&
          formData.birthdate === '' &&
          addNew === false
        ) {
          history.push('/resume')
        } else {
          try {
            formRef.current?.setErrors({})

            const schema = Yup.object().shape({
              grauParentesco: Yup.string(),
              name: Yup.string()
                .required('Seu nome é obrigatório.')
                .matches(/\s/g, 'Digite o nome completo')
                .min(3, 'Digite o nome completo'),
              birthdate: Yup.string()
                .required('Data de nascimento é obrigatória')
                .test(
                  '',
                  'A data de nascimento não pode ser maior que hoje.',
                  () =>
                    moment() >
                      moment(
                        formData.birthdate.split('/').reverse().join('-'),
                      ) || formData.birthdate === '',
                )
                .test(
                  '',
                  'Data de nascimento inválida',
                  () =>
                    moment(
                      formData.birthdate.split('/').reverse().join('-'),
                    ).isValid() || formData.birthdate === '',
                )
                .test(
                  '',
                  'Data de nascimento inválida',
                  () =>
                    calculaIdade(
                      formData.birthdate.split('/').reverse().join('-'),
                    ) <= 100 || formData.birthdate === '',
                )
                .test(
                  '',
                  'Data de nascimento inválida para cônjuge ou companheiro',
                  () =>
                    (formData.grauParentesco !== '1' &&
                      formData.grauParentesco !== '2') ||
                    calculaIdade(
                      formData.birthdate.split('/').reverse().join('-'),
                    ) >= 16 ||
                    formData.birthdate === '',
                ),
              cpf: Yup.string()
                .required('CPF é obrigatório')
                .test('', 'CPF já utilizado em outro cadastro', function v() {
                  const t2 =
                    (participantsList.filter(
                      part => part.data.cpf === formData.cpf,
                    ).length <= 0 &&
                      formData.cpf !== userData.cpf) ||
                    formData.cpf === ''
                  return t2
                })
                .test('', 'CPF inválido', function t() {
                  const teste =
                    validaCPF(
                      formData.cpf.replaceAll('.', '').replace('-', ''),
                    ) || formData.cpf === ''
                  return teste
                }),
            })

            await schema.validate(formData, { abortEarly: false })

            const dataForm = formData.birthdate.split('/').reverse().join('-')

            await setThisParticipant({
              ...thisParticipant,
              data: {
                name: formData.name,
                cpf: formData.cpf,
                birthdate: formData.birthdate === '' ? '' : dataForm,
              },
              details: {
                proporcao: 0,
                tipVinculo: '',
                tipoBen: '',
                grauParentesco: grauParent.value,
                dcrGrauParentesco: grauParent.label,
              },
            })

            await setParticipantsList([
              ...participantsList,
              {
                ...thisParticipant,
                data: {
                  name: formData.name,
                  cpf: formData.cpf,
                  birthdate: formData.birthdate === '' ? '' : dataForm,
                },
                details: {
                  proporcao: 0,
                  tipVinculo: '',
                  tipoBen: '',
                  grauParentesco: grauParent.value,
                  dcrGrauParentesco: grauParent.label,
                },
              },
            ])

            formRef.current?.reset()

            if (addNew === false) {
              history.push('/resume')
            }
          } catch (err) {
            formRef.current?.setErrors(getValidationErrors(err))
          }
        }
      } else {
        // CONTINUA QUANDO NÃO POSSUI BENEFICIÁRIO
        await setParticipantsList([])
        history.push('/resume')
      }
    },
    [
      addNew,
      addParticipant,
      grauParent,
      history,
      participantsList,
      setParticipantsList,
      thisParticipant,
      userData.cpf,
    ],
  )

  const handleChangeValues = useCallback(() => {
    history.push('/fatca')
  }, [history])

  const handleAddNew = useCallback(async () => {
    await setAddNew(true)
    await formRef.current?.submitForm()
  }, [])

  const handleContinue = useCallback(async () => {
    await setAddNew(false)
    await formRef.current?.submitForm()
  }, [])

  return (
    <>
      <Header>
        <FiArrowLeft
          type="button"
          cursor="pointer"
          onClick={handleChangeValues}
        />
      </Header>
      <Container>
        <Content>
          <h3>
            <strong>Adicionar beneficiários</strong> ao plano Família Ceres.
          </h3>

          <InfoBox>
            <span>Tem algum beneficiário para indicar?</span>
            <RadioButton>
              <div>
                <BtnContato
                  type="button"
                  isActive={addParticipant === 'S'}
                  onClick={() => setAddParticipant('S')}
                >
                  Sim
                </BtnContato>
                <BtnContato
                  type="button"
                  isActive={addParticipant === 'N'}
                  onClick={() => setAddParticipant('N')}
                >
                  Não
                </BtnContato>
              </div>
            </RadioButton>
          </InfoBox>

          <Collapse in={addParticipant === 'S'} className="collapse">
            <Form ref={formRef} onSubmit={handleSubmit}>
              <BenefBox>
                <small>Beneficiário</small>

                <InputSelect
                  name="grauParentesco"
                  options={[
                    { label: 'Cônjuge', value: '1' },
                    { label: 'Companheiro(a)', value: '2' },
                    { label: 'Filho(a) Consanguíneo(a)', value: '3' },
                    {
                      label: 'Filho(a) Consanguíneo(a) Inválido(a)',
                      value: '4',
                    },
                    { label: 'Neto(a) Consanguíneo(a)', value: '13' },
                    { label: 'Neto(a) por Afinidade', value: '14' },
                    { label: 'Bisneto(a) Consanguíneo(a)', value: '15' },
                    { label: 'Bisneto(a) por Afinidade', value: '16' },
                    { label: 'Pai/Mãe Consanguíneo(a)', value: '5' },
                    { label: 'Pai/Mãe por Afinidade', value: '17' },
                    { label: 'Avô/Avó Consanguíneo(a)', value: '18' },
                    { label: 'Avô/Avó por Afinidade', value: '19' },
                    { label: 'Bisavô/Bisavó Consanguíneo(a)', value: '20' },
                    { label: 'Bisavô/Bisavó por Afinidade', value: '21' },
                    { label: 'Irmão(ã) Consanguíneo(a)', value: '22' },
                    { label: 'Irmão(ã) por Afinidade', value: '23' },
                    { label: 'Tio(a) Consanguíneo(a)', value: '24' },
                    { label: 'Tio(a) por Afinidade', value: '25' },
                    { label: 'Sobrinho(a) Consanguíneo(a)', value: '26' },
                    { label: 'Sobrinho(a) por Afinidade', value: '27' },
                    { label: 'Menor Tutelado Consanguíneo', value: '28' },
                    { label: 'Menor Tutelado por Afinidade', value: '29' },
                    {
                      label: 'Menor sob Guarda Judicial Consanguíneo',
                      value: '30',
                    },
                    {
                      label: 'Menor sob Guarda Judicial por Afinidade',
                      value: '31',
                    },
                    { label: 'Nora/Genro', value: '32' },
                    { label: 'Outros', value: '0' },
                  ]}
                  placeholder="Tipo de Vínculo"
                  onChange={e => handleChangeGrauParentesco(e)}
                />
                <Input name="name" placeholder="Nome Completo" icon={FiUser} />
                <Input
                  placeholder="CPF"
                  name="cpf"
                  icon={MdSecurity}
                  type="tel"
                  mask="cpf"
                  required
                />
                <Input
                  icon={BiCake}
                  name="birthdate"
                  mask="date"
                  placeholder="Data de nascimento"
                />
              </BenefBox>
            </Form>

            {participantsList.map((p, idx) => (
              <BenefBox key={Math.random()}>
                <FiX onClick={() => handleRemove(idx)} />
                <small>{idx + 1}. Beneficiário</small>
                <BenefBoxInfos>
                  <div>
                    <span>Tipo de vínculo</span>
                    <p>{p.details.dcrGrauParentesco}</p>
                  </div>
                  <div>
                    <span>Nome completo</span>
                    <div>
                      <FiUser />
                      <p>{p.data.name}</p>
                    </div>
                  </div>
                  <div>
                    <span>CPF</span>
                    <div>
                      <MdSecurity />
                      <p>{p.data.cpf}</p>
                    </div>
                  </div>
                  <div>
                    <span>Data de nascimento</span>
                    <div>
                      <BiCake />
                      <p>{p.data.birthdate.split('-').reverse().join('/')}</p>
                    </div>
                  </div>
                </BenefBoxInfos>
              </BenefBox>
            ))}

            <Button type="button" color="transparent" onClick={handleAddNew}>
              <div>
                <FiPlus />
              </div>
              Adicionar beneficiário
            </Button>
          </Collapse>

          <Collapse in={addParticipant === 'N'} className="collapse">
            <InfoBox>
              <h3>Nenhum beneficiário informado.</h3>
            </InfoBox>
          </Collapse>
        </Content>

        <Button type="button" color="green" onClick={handleContinue}>
          Continuar
          <div>
            <FiArrowRight />
          </div>
        </Button>
      </Container>
    </>
  )
}

export default ParticipantsList
